/* eslint-disable no-undef */
import React, { useState } from 'react';
import { theme } from '../../../../db.json';
import { ContainerMenu, ContainerFormForStatusFooter } from '../../../../components/Containers';
import HeaderTitle from '../../../../components/HeaderTitle';
import ButtonOptionSystem from '../../../../components/NovoSistema/ButtonOptionSystem';
import { SelectSystemHeader } from '../../../../components/NovoSistema/SelectSystemHeader';
import GestaoDeCustos from '../GestaoDeCustos';

export default function TemplateFinanceiroHospitalar() {
  const [systemOption, setSystemOption] = useState('');
  const themeColors = theme.colors.systems;

  return (
    <ContainerMenu>
      <ContainerFormForStatusFooter>
        <HeaderTitle text="Financeiro Hospitalar" linkIcon="/images/icons/financeHospital.svg" />
        <SelectSystemHeader>
          <ButtonOptionSystem
            systemName="Param. Regras"
            color=""
            border={themeColors.NS.FinanceiroHospitalar}
            active={systemOption === 'Param. Regras' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Central de Guias"
            color=""
            border={themeColors.NS.FinanceiroHospitalar}
            active={systemOption === 'Central de Guias' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Auditoria"
            color=""
            border={themeColors.NS.FinanceiroHospitalar}
            active={systemOption === 'Auditoria' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Fechamento Contas"
            color=""
            border={themeColors.NS.FinanceiroHospitalar}
            active={systemOption === 'Fechamento Contas' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Geração XML"
            color=""
            border={themeColors.NS.FinanceiroHospitalar}
            active={systemOption === 'Geração XML' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Glosas"
            color=""
            border={themeColors.NS.FinanceiroHospitalar}
            active={systemOption === 'Glosas' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Recursos de Glosa"
            color=""
            border={themeColors.NS.FinanceiroHospitalar}
            active={systemOption === 'Recursos de Glosa' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Gestão de Custos"
            color=""
            border={themeColors.NS.FinanceiroHospitalar}
            active={systemOption === 'Gestão de Custos' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
        </SelectSystemHeader>
        {systemOption === 'Param. Regras' && <div></div>}
        {systemOption === 'Central de Guias' && <div></div>}
        {systemOption === 'Auditoria' && <div></div>}
        {systemOption === 'Fechamento Contas' && <div></div>}
        {systemOption === 'Geração XML' && <div></div>}
        {systemOption === 'Glosas' && <div></div>}
        {systemOption === 'Recursos de Glosa' && <div></div>}
        {systemOption === 'Gestão de Custos' && <GestaoDeCustos />}
      </ContainerFormForStatusFooter>
    </ContainerMenu>
  );
}
